import { useEffect, useState } from 'react';
import * as yup from 'yup';
import { axiosInstance } from '../../../../api/axios';
import APIEndpoints from '../../../api/APIEndpoints';
import { HttpSuccessCodes } from '../../../errorhandling/HttpErrorCodes';

const useOneTimePassword = ({
  email,
  nextStep,
  OTPExpiry,
  OTPLength,
  OTPAttempts,
}) => {
  const [serverError, setServerError] = useState(false);
  const [oneTimePassword, setOneTimePassword] = useState('');
  const [accountLocked, setAccountLocked] = useState(false);
  const [loader, setLoader] = useState(false);
  const [disabledContinueButton, setDisabledContinueButton] = useState(false);
  let timerId = null;

  const schema = yup.object({
    oneTimePassword: yup
      .string()
      .matches(
        /^[0-9]*$/,
        'Enter your ' + OTPLength + '-digit authentication code',
      )
      .min(OTPLength, 'Enter your ' + OTPLength + '-digit authentication code')
      .max(OTPLength, 'Enter your ' + OTPLength + '-digit authentication code')
      .required('Enter your ' + OTPLength + '-digit authentication code'),
  });

  const maskEmail = (email) => {
    if (email) {
      const emailLength = email?.length;

      const pos = email.indexOf('@');
      return (
        email.substring(0, 3) +
        email.substring(3, pos).replace(/[a-z,A-Z]/gi, 'x') +
        email.substring(pos, emailLength)
      );
    }
  };

  const validateOTP = async () => {
    try {
      setLoader(true);
      const response = await axiosInstance.get(
        APIEndpoints.getOtpVerifyResources() +
          oneTimePassword +
          '/userid/' +
          email +
          '/alternateemail/true',
      );
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        setLoader(false);
        return new Promise((resolve, reject) => {
          resolve('success');
        });
      } else {
        setLoader(false);
        return new Promise((resolve, reject) => {
          reject('Unable to verify your OTP code now.');
        });
      }
    } catch (e) {
      if (e.response.status === 400) {
        let failedCount = false;
        const errorMessage = e.response.data.message.replace(/[\\["\]]/g, '');
        errorMessage.indexOf('Account locked') > 0
          ? setAccountLocked(true)
          : setAccountLocked(false);
        errorMessage.indexOf('Failed count') > 0
          ? (failedCount = true)
          : (failedCount = false);
        const attemptedCount = parseInt(
          errorMessage.substring(errorMessage.length - 1, errorMessage.length),
        );
        let pendingAttempts = OTPAttempts - attemptedCount;
        console.log('debug_check', attemptedCount, pendingAttempts);
        if (
          isNaN(attemptedCount) ||
          errorMessage.indexOf('Account locked') > 0
        ) {
          pendingAttempts = -1;
        }
        if (accountLocked || pendingAttempts < 0) {
          setAccountLocked(true);
          setLoader(false);
          setDisabledContinueButton(true);
          return new Promise((resolve, reject) => {
            reject(
              'You have exceeded the maximum OTP attempts! To register, you need to restart the registration process.',
            );
          });
        } else if (failedCount) {
          setLoader(false);
          return new Promise((resolve, reject) => {
            reject(`Invalid OTP. 
              ${pendingAttempts === 0 ? 'Final' : pendingAttempts + 1} 
              ${pendingAttempts <= 1 ? 'Attempt' : 'Attempts'} Left.`);
          });
        } else {
          setLoader(false);
          return new Promise((resolve, reject) => {
            reject('Unable to verify your OTP code now.');
          });
        }
      } else {
        setLoader(false);
        return new Promise((resolve, reject) => {
          reject('Unable to verify your OTP code now.');
        });
      }
    }
  };

  const timer = (remaining) => {
    clearTimeout(timerId);

    let s = remaining % 60;
    let m = Math.floor(remaining / 60);

    m = m < 10 ? '0' + m : m;
    s = s < 10 ? '0' + s : s;

    const element = document.getElementById('otp-timer');

    if (element) element.innerHTML = m + ':' + s;

    remaining -= 1;

    if (remaining >= 0) {
      timerId = setTimeout(() => {
        timer(remaining);
      }, 1000);

      return;
    }
  };

  const generateOTP = async () => {
    try {
      const response = await axiosInstance.get(
        APIEndpoints.getOtpGenerateResources() + email,
      );
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        const OTPExpiryTimeout = parseInt(OTPExpiry || 5) * 60;
        timer(OTPExpiryTimeout);
      } else {
        setServerError(true);
      }
    } catch (e) {
      setServerError(true);
    }
  };

  useEffect(() => {
    generateOTP();
  }, []);

  return {
    schema,
    serverError,
    accountLocked,
    loader,
    maskEmail,
    validateOTP,
    generateOTP,
    setOneTimePassword,
    disabledContinueButton,
  };
};
export default useOneTimePassword;
